const BASE_URL = "https://api.konnxt.com:82";

export default BASE_URL;